<template>
  <ul class=" font-bold max-w-6xl container mx-auto nav pb-2 mb-10">
    <li class="inline pr-6">
      <router-link active-class="text-brand-blue" to="/">Projects</router-link>
    </li>
    <li class="inline pr-6">
      <router-link to="/projects">Billing</router-link>
    </li>
    <li class="inline">
      <router-link to="/projects">Account</router-link>
    </li>
  </ul>
</template>

<script>

export default {
  name: 'Nav'

}
</script>

<style scoped lang="scss">
.nav{
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  li{
    color: rgba(50, 77, 91, 0.6)
  }
}

</style>
